class VariantAwareElement extends HTMLElement {
  constructor() {
    super()

    this.outlet.attachShadow({ mode: 'open' })
    this.update()

    this.productInput && this.productInput.addEventListener('change', this.update.bind(this))
  }

  get productInput() {
    return document.querySelector('form[is="product-form"] input[name="id"]')
  }

  get outlet() {
    return this.querySelector('[role="outlet"]')
  }

  update() {
    const productInput = this.productInput.value
    const outlet = this.outlet
    const el = outlet.querySelector(`[data-product-id="${productInput}"]`)
    if (!el) throw new Error(`could not find content for product ${productInput}`)

    const copy = el.cloneNode(true)
    if (outlet.shadowRoot.firstChild) {
      outlet.shadowRoot.replaceChild(copy, outlet.shadowRoot.firstChild)
    } else {
      outlet.shadowRoot.appendChild(copy)
    }
  }
}

if (!customElements.get('variant-aware')) {
  customElements.define('variant-aware', VariantAwareElement)
}
